import React, { useState } from "react";
import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Avatar,
  Divider,
  Menu,
  MenuItem,
  Snackbar,
  CircularProgress,
  Collapse,
} from "@mui/material";
import {
  KeyboardArrowDown as ArrowDownIcon,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
// import {
//   SettingIcon,
//   HelpIcon,
// } from "../../assets/svg";
import BackstageLogo from '../../assets/images/BackstageLogo.png'
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { handleLogout } from "../../services/authService";
// import { ReactComponent as SearchIcon } from '../../assets/svg/search.svg';
import { ReactComponent as Dashboard } from '../../assets/svg/dashboard.svg';
import { ReactComponent as User } from '../../assets/svg/tag-user.svg';
import { ReactComponent as People } from '../../assets/svg/people.svg';
import { ReactComponent as UserOctagon } from '../../assets/svg/user-octagon.svg';
import { ReactComponent as CardPos } from '../../assets/svg/card-pos.svg';
import { ReactComponent as DirectboxSend } from '../../assets/svg/directbox-send.svg';
import { ReactComponent as Cube } from '../../assets/svg/3dcube.svg';
// import { ReactComponent as UserSquareBlack } from '../../assets/svg/user-square-black.svg';
import { ReactComponent as Element } from '../../assets/svg/element-3.svg';
import { ReactComponent as Layer } from '../../assets/svg/layer.svg';
import { ReactComponent as FrameworkIcon } from '../../assets/svg/data-2.svg';
import { ReactComponent as TranslateIcon } from '../../assets/svg/translate.svg';
import { useUser } from "../UserContext";
// import { ReactComponent as ClipboardTick } from '../../assets/svg/clipboard-tick.svg';

const drawerWidth = 280;

const menuItems = [
  {
    name: "Dashboard",
    icon: <Dashboard />,
    link: "/",
  },
  {
    name: "Customer",
    icon: <People />,
    submenu: [
      { name: "Organizations", link: "/customer/organizations", icon: <UserOctagon /> },
      { name: "License Plans", link: "/customer/license", icon: <CardPos /> },
      { name: "Sign-ups", link: "/customer/signups", icon: <DirectboxSend /> },
    ],
  },
  {
    name: "User Management",
    icon: <User />,
    link: "/user/management",
  },
  {
    name: "Master Management",
    icon: <Cube />,
    submenu: [
      // { name: "Vendors", link: "/master/vendors", icon: <UserSquareBlack /> },
      { name: "Categories", link: "/master/categories", icon: <Element /> },
      { name: "Services", link: "/master/services", icon: <Layer /> },
      { name: "Framework", link: "/master/frameworks", icon: <FrameworkIcon /> },
      { name: "Language", link: "/master/language", icon: <TranslateIcon /> },
    ],
  },
  // {
  //   name: "Approval Management",
  //   icon: <ClipboardTick />,
  //   submenu: [
  //     { name: "Coming soon...", link: null, disabled: true }
  //   ],
  // },
];

const Sidebar = ({ isMobile, mobileOpen, onDrawerToggle }) => {
  const { currentUser, loading } = useUser();
  // const [selectedItem, setSelectedItem] = useState("Dashboard");
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const navigate = useNavigate(); // Use useNavigate hook
  const location = useLocation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (name) => {
    setOpenMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const isActive = (path) => {
    if (!path) return false;
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? mobileOpen : true}
      onClose={isMobile ? onDrawerToggle : undefined}
      ModalProps={{
        keepMounted: true, // Better mobile performance
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          bgcolor: "#F9FAFB",
          border: "none",
          borderRight: "1px solid #EAEAEA",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
      }}
    >
      {/* Top Section */}
      <Box>
        {/* Header Section */}
        <Box>
          <Box sx={{ p: 2, display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
            <img src={BackstageLogo} alt="" style={{ width: '180px' }} />
            {/* <Box sx={{ border: '1px solid #D3D3D3', borderRadius: '7px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} >
              <SearchIcon />
            </Box> */}
          </Box>
          <Divider />
          <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
            <Avatar
              sx={{
                width: 30,
                height: 30,
                mr: 2,
                color: "#525455",
                fontWeight: "bold",
                background: "#E9E9E9",
              }}
            >
              {currentUser?.name?.charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography fontWeight="500">Hello, {loading ?
                <CircularProgress size={20} color="main" />
                : currentUser?.name}</Typography>
            </Box>
            <IconButton
              onClick={handleClick}
            >
              <ArrowDownIcon />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem
                onClick={() => {
                  navigate("/profile");
                  setAnchorEl(null); // Close the menu after navigation
                }}
              >
                Profile
              </MenuItem>
              <Divider />
              <MenuItem onClick={() => { handleLogout(navigate) }}>
                Sign Out
              </MenuItem>
            </Menu>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={3000} // Automatically close after 3 seconds
              onClose={() => setSnackbarOpen(false)} // Close handler
              message={"Successfully logged out!"}
              anchorOrigin={{ vertical: "top", horizontal: "right" }} // Position: Top-right
            />
          </Box>
        </Box>
        <Divider />

        {/* Main Menu */}
        <Box sx={{ p: 1 }}>
          <List>
            {menuItems.map((item) => {
              if (currentUser?.zoneinfo === "product_user" && (item.name === "User Management" || item.name === "Customer")) {
                return null; // <-- Explicitly return null to avoid warning
              }

              return (
                <Box key={item.name}>
                  <ListItemButton
                    onClick={() =>
                      item.submenu
                        ? toggleMenu(item.name)
                        : navigate(item.link)
                    }
                    selected={isActive(item.link)}
                    sx={{
                      backgroundColor: isActive(item.link) ? "#FEF3F0" : "transparent",
                      color: isActive(item.link) ? "#FF6348" : "inherit",
                      "&:hover": {
                        backgroundColor: "#FEF3F0",
                      },
                      borderRadius: "8px",
                      mx: 1,
                      my: 0.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{ color: isActive(item.link) ? "#FF6348" : '#525455', minWidth: '40px' }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.name} />
                    {item.submenu && (openMenus[item.name] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {item.submenu && (
                    <Collapse in={openMenus[item.name]} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.submenu.map((sub) => (
                          <ListItemButton
                            key={sub.name}
                            sx={{
                              pl: 4,
                              backgroundColor: isActive(sub.link) ? "#FEF3F0" : "transparent",
                              color: isActive(sub.link) ? "#FF6348" : "inherit",
                              "&:hover": {
                                backgroundColor: "#FEF3F0",
                              },
                              borderRadius: "8px",
                              mx: 1,
                              my: 0.5,
                            }}
                            selected={isActive(sub.link)}
                            disabled={sub.disabled}
                            onClick={() => sub.link && navigate(sub.link)}
                          >
                            <ListItemIcon sx={{ color: isActive(sub.link) ? "#FF6348" : "inherit", minWidth: '40px' }}>
                              {sub.icon}
                            </ListItemIcon>
                            <ListItemText primary={sub.name} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </Box>
              );
            })}
          </List>
        </Box>
      </Box>

      {/* Footer Section */}
      {/* <Box sx={{ p: 2 }}>
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ mb: 1, ml: 2 }}
        >
          OTHER
        </Typography>
        <List>
          <ListItemButton
            sx={{
              backgroundColor:
                selectedItem === "Settings" ? "#FEF3F0" : "transparent",
              "&:hover": {
                backgroundColor: "#FEF3F0",
              },
              "&.Mui-selected": {
                backgroundColor: "#FEF3F0 !important",
                "&:hover": {
                  backgroundColor: "#FEF3F0",
                },
              },
              "& .MuiListItemIcon-root": {
                color: selectedItem === "Settings" ? "#FF6348" : "inherit",
              },
              "& .MuiListItemText-primary": {
                color: selectedItem === "Settings" ? "#FF6348" : "inherit",
              },
              borderRadius: "8px",
              mx: 1,
              my: 0.5,
            }}
            onClick={() => handleMenuItemClick("Settings")}
            disabled={userInfo?.zoneinfo === "Org_user"}
          >
            <ListItemIcon
              sx={{
                minWidth: "40px",
                "& svg": {
                  width: "20px",
                  height: "20px",
                  // Apply green filter when selected
                  filter:
                    selectedItem === "Settings"
                      ? "invert(46%) sepia(72%) saturate(2499%) hue-rotate(133deg) brightness(96%) contrast(105%)"
                      : "none",
                },
              }}
            >
              <SettingIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItemButton>
          <ListItemButton
            sx={{
              backgroundColor:
                selectedItem === "Help & Support" ? "#FEF3F0" : "transparent",
              "&:hover": {
                backgroundColor: "#FEF3F0",
              },
              "&.Mui-selected": {
                backgroundColor: "#FEF3F0 !important",
                "&:hover": {
                  backgroundColor: "#FEF3F0",
                },
              },
              "& .MuiListItemIcon-root": {
                color:
                  selectedItem === "Help & Support" ? "#FF6348" : "inherit",
              },
              "& .MuiListItemText-primary": {
                color:
                  selectedItem === "Help & Support" ? "#FF6348" : "inherit",
              },
              borderRadius: "8px",
              mx: 1,
              my: 0.5,
            }}
            onClick={() => handleMenuItemClick("Help & Support")}
          >
            <ListItemIcon
              sx={{
                minWidth: "40px",
                "& svg": {
                  width: "20px",
                  height: "20px",
                  // Apply green filter when selected
                  filter:
                    selectedItem === "Help & Support"
                      ? "invert(46%) sepia(72%) saturate(2499%) hue-rotate(133deg) brightness(96%) contrast(105%)"
                      : "none",
                },
              }}
            >
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="Help & Support" />
          </ListItemButton>
        </List>
      </Box> */}
    </Drawer>
  );
};

export default Sidebar;
